import HTMLHead from "../../components/blocks/HTMLHead";
import MetaElement from "../../components/elements/MetaElement";

const LorwynEclipsedLanding = () => {
    const products = [
        {
            name: "Prerelease Pack",
            price: "159.99",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/ECL-004_SDFGHJHBGJ_Prerelease_EN.webp",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-prerelease-pack",
            badge: "PRERELEASE",
            soldOut: true
        },
        {
            name: "Play Booster Display",
            price: "749.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/ECL-004_SDFGHJHBGJ_Play_EN.webp",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-play-booster-display-30-packs",
            badge: null,
            soldOut: false
        },
        {
            name: "Collector Booster Display",
            price: "1609.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/ECL-004_SDFGHJHBGJ_Collector_EN.webp",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-collectors-booster-display-12-packs",
            badge: "PREMIUM",
            soldOut: false
        },
        {
            name: "Bundle",
            price: "299.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/ECL-004_SDFGHJHBGJ_Bundle_EN.webp",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-bundle",
            badge: null,
            soldOut: true
        },
        {
            name: "Commander Deck - Blight Curse",
            price: "249.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/Untitled%20design%20(2).png",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-blight-curse-commander-deck",
            badge: "COMMANDER",
            soldOut: false
        },
        {
            name: "Commander Deck - Dance of the Elements",
            price: "249.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/cmdr-dance-of-the-elements.png",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-dance-of-the-elements-commander-deck",
            badge: "COMMANDER",
            soldOut: false
        },
        {
            name: "Theme Deck - Angels",
            price: "135.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/Untitled%20design%20(4).png",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-theme-deck-angels",
            badge: "STANDARD",
            soldOut: true
        },
        {
            name: "Theme Deck - Pirates",
            price: "135.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/Untitled%20design%20(3).png",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-theme-deck-pirates",
            badge: "STANDARD",
            soldOut: false
        },
        {
            name: "Draft Night",
            price: "529.00",
            image: "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/ECL-004_SDFGHJHBGJ_DraftNight_EN.webp",
            url: "https://krit.ro/produs/magic-the-gathering-lorwyn-eclipsed-draft-night",
            badge: null,
            soldOut: false
        }
    ];

    const events = [
        {
            title: "Prerelease #1 Ploiești",
            date: "Vineri, 16 Ianuarie 2026",
            time: "18:30",
            location: "KRIT Ploiești",
            address: "Str. Buna Vestire, Nr. 55, Ploiești",
            locationLogo: "https://content.krit.ro/public-assets/other-resource/krit_preview_ploiesti_rev3.png",
            price: "149.00 LEI",
            url: "https://krit.ro/calendar/event/magic-the-gathering-lorwyn-eclipsed-prerelease-1-ploiesti-2026-01-16",
            soldOut: false
        },
        {
            title: "Prerelease #2 Ploiești",
            date: "Duminică, 18 Ianuarie 2026",
            time: "13:00",
            location: "KRIT Ploiești",
            address: "Str. Buna Vestire, Nr. 55, Ploiești",
            locationLogo: "https://content.krit.ro/public-assets/other-resource/krit_preview_ploiesti_rev3.png",
            price: "149.00 LEI",
            url: "https://krit.ro/calendar/event/magic-the-gathering-lorwyn-eclipsed-prerelease-2-ploiesti-2026-01-18",
            soldOut: false
        },
        {
            title: "Prerelease #1 Brașov",
            date: "Vineri, 16 Ianuarie 2026",
            time: "18:30",
            location: "KRIT Brașov",
            address: "Str. Lunga, Nr. 51, Brașov",
            locationLogo: "https://content.krit.ro/public-assets/other-resource/krit_preview_brasov_rev3.png",
            price: "149.00 LEI",
            url: "https://krit.ro/calendar/event/magic-the-gathering-lorwyn-eclipsed-prerelease-1-brasov-2026-01-16",
            soldOut: false
        },
        {
            title: "Prerelease #2 Brașov",
            date: "Sâmbătă, 17 Ianuarie 2026",
            time: "13:00",
            location: "KRIT Brașov",
            address: "Str. Lunga, Nr. 51, Brașov",
            locationLogo: "https://content.krit.ro/public-assets/other-resource/krit_preview_brasov_rev3.png",
            price: "149.00 LEI",
            url: "https://krit.ro/calendar/event/magic-the-gathering-lorwyn-eclipsed-prerelease-2-brasov-2026-01-17",
            soldOut: true
        }
    ];

    return (
        <>
            <HTMLHead />
            <MetaElement
                pageId="landing/mtg-lorwyn-eclipsed"
            />

            <style global jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Inter:wght@400;500;600;700&display=swap');

                :root {
                    --lorwyn-gold: #c9a227;
                    --lorwyn-gold-light: #e8d078;
                    --lorwyn-purple: #4a1a6b;
                    --lorwyn-purple-dark: #2a0d3e;
                    --lorwyn-green: #1a4a2e;
                    --lorwyn-green-light: #2d6b43;
                    --shadowmoor-dark: #0d0d1a;
                    --shadowmoor-blue: #1a2040;
                    --text-light: #f5f5f5;
                    --text-muted: #b0b0b0;
                }

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                html, body, #__next {
                    background-color: var(--shadowmoor-dark);
                    scroll-behavior: smooth;
                }

                .landing-container {
                    width: 100%;
                    min-height: 100vh;
                    font-family: 'Inter', sans-serif;
                    color: var(--text-light);
                    overflow-x: hidden;
                }

                /* Hero Section */
                .hero {
                    position: relative;
                    width: 100%;
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(180deg,
                        rgba(13, 13, 26, 0.3) 0%,
                        rgba(13, 13, 26, 0.7) 50%,
                        rgba(13, 13, 26, 1) 100%),
                        url('https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/3H8hMTEhhnho_HeroHeader_1023x600.webp');
                    background-size: cover;
                    background-position: center top;
                    background-repeat: no-repeat;
                    padding: 40px 20px;
                }

                .krit-badge {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    z-index: 1000;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 4px;
                    transition: all 0.3s ease;
                    text-decoration: none;
                }

                .krit-badge:hover {
                    transform: scale(1.05);
                }

                .krit-badge-logo {
                    height: 60px;
                    width: auto;
                    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.6));
                }

                .krit-badge-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 0.9rem;
                    color: var(--lorwyn-gold);
                    text-transform: uppercase;
                    letter-spacing: 1.5px;
                    font-weight: 700;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
                    text-align: center;
                    width: 100%;
                    background: rgba(0, 0, 0, 0.7);
                    padding: 8px 16px;
                    border-radius: 20px;
                    border: 1px solid var(--lorwyn-gold);
                }

                .hero::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(ellipse at center top, transparent 30%, var(--shadowmoor-dark) 80%);
                    pointer-events: none;
                }

                .hero-content {
                    position: relative;
                    z-index: 10;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    max-width: 900px;
                }

                .magic-logo {
                    width: 100%;
                    max-width: 200px;
                    margin-bottom: 20px;
                    filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0.8));
                }

                .hero-logo {
                    width: 100%;
                    max-width: 600px;
                    margin-bottom: 20px;
                    filter: drop-shadow(0 0 30px rgba(201, 162, 39, 0.5));
                    animation: float 4s ease-in-out infinite;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                @keyframes particleFloat {
                    0% {
                        transform: translateY(0) translateX(0) scale(0);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    90% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(-100vh) translateX(var(--drift)) scale(1);
                        opacity: 0;
                    }
                }

                .particles {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    pointer-events: none;
                    z-index: 1;
                }

                .particle {
                    position: absolute;
                    bottom: -10px;
                    width: 4px;
                    height: 4px;
                    background: var(--lorwyn-gold);
                    border-radius: 50%;
                    box-shadow: 0 0 10px var(--lorwyn-gold), 0 0 20px var(--lorwyn-gold-light);
                    animation: particleFloat linear infinite;
                }

                .particle:nth-child(1) { left: 10%; animation-duration: 8s; animation-delay: 0s; --drift: 20px; }
                .particle:nth-child(2) { left: 20%; animation-duration: 10s; animation-delay: 1s; --drift: -15px; }
                .particle:nth-child(3) { left: 30%; animation-duration: 9s; animation-delay: 2s; --drift: 30px; }
                .particle:nth-child(4) { left: 40%; animation-duration: 11s; animation-delay: 0.5s; --drift: -20px; }
                .particle:nth-child(5) { left: 50%; animation-duration: 7s; animation-delay: 1.5s; --drift: 10px; }
                .particle:nth-child(6) { left: 60%; animation-duration: 12s; animation-delay: 2.5s; --drift: -25px; }
                .particle:nth-child(7) { left: 70%; animation-duration: 9s; animation-delay: 0.8s; --drift: 15px; }
                .particle:nth-child(8) { left: 80%; animation-duration: 10s; animation-delay: 3s; --drift: -10px; }
                .particle:nth-child(9) { left: 15%; animation-duration: 8s; animation-delay: 1.2s; --drift: -30px; }
                .particle:nth-child(10) { left: 25%; animation-duration: 11s; animation-delay: 2.8s; --drift: 25px; }
                .particle:nth-child(11) { left: 35%; animation-duration: 9s; animation-delay: 0.3s; --drift: -5px; }
                .particle:nth-child(12) { left: 45%; animation-duration: 10s; animation-delay: 1.8s; --drift: 20px; }
                .particle:nth-child(13) { left: 55%; animation-duration: 12s; animation-delay: 0.6s; --drift: -15px; }
                .particle:nth-child(14) { left: 65%; animation-duration: 8s; animation-delay: 2.2s; --drift: 10px; }
                .particle:nth-child(15) { left: 75%; animation-duration: 11s; animation-delay: 1.5s; --drift: -20px; }
                .particle:nth-child(16) { left: 85%; animation-duration: 9s; animation-delay: 3.2s; --drift: 15px; }
                .particle:nth-child(17) { left: 90%; animation-duration: 10s; animation-delay: 0.9s; --drift: -25px; }
                .particle:nth-child(18) { left: 5%; animation-duration: 8s; animation-delay: 2.5s; --drift: 30px; }
                .particle:nth-child(19) { left: 95%; animation-duration: 12s; animation-delay: 1.1s; --drift: -10px; }
                .particle:nth-child(20) { left: 50%; animation-duration: 9s; animation-delay: 3.5s; --drift: 5px; }

                .hero-tagline {
                    font-family: 'Cinzel', serif;
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: var(--lorwyn-gold-light);
                    margin-bottom: 10px;
                    text-shadow: 0 2px 20px rgba(0,0,0,0.8);
                    letter-spacing: 3px;
                    text-transform: uppercase;
                }

                .hero-subtitle {
                    font-size: 1.1rem;
                    color: var(--text-muted);
                    margin-bottom: 30px;
                    max-width: 600px;
                    line-height: 1.6;
                }

                .release-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    background: linear-gradient(135deg, var(--lorwyn-purple) 0%, var(--lorwyn-purple-dark) 100%);
                    border: 2px solid var(--lorwyn-gold);
                    border-radius: 50px;
                    padding: 15px 30px;
                    margin-bottom: 30px;
                    box-shadow: 0 0 30px rgba(201, 162, 39, 0.3);
                }

                .release-badge-label {
                    font-size: 0.85rem;
                    color: var(--lorwyn-gold-light);
                    text-transform: uppercase;
                    letter-spacing: 2px;
                }

                .release-badge-date {
                    font-family: 'Cinzel', serif;
                    font-size: 1.4rem;
                    font-weight: 700;
                    color: var(--text-light);
                }

                .hero-buttons {
                    display: flex;
                    gap: 20px;
                    flex-wrap: wrap;
                    justify-content: center;
                }

                .btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 16px 40px;
                    font-family: 'Inter', sans-serif;
                    font-size: 1rem;
                    font-weight: 700;
                    text-decoration: none;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    border: none;
                }

                .btn-primary {
                    background: linear-gradient(135deg, var(--lorwyn-gold) 0%, var(--lorwyn-gold-light) 100%);
                    color: var(--shadowmoor-dark);
                    box-shadow: 0 4px 20px rgba(201, 162, 39, 0.4);
                }

                .btn-primary:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 30px rgba(201, 162, 39, 0.6);
                }

                .btn-secondary {
                    background: transparent;
                    color: var(--text-light);
                    border: 2px solid var(--lorwyn-gold);
                }

                .btn-secondary:hover {
                    background: rgba(201, 162, 39, 0.1);
                    transform: translateY(-3px);
                }

                .scroll-indicator {
                    position: absolute;
                    bottom: 40px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    color: var(--text-muted);
                    font-size: 0.85rem;
                    animation: bounce 2s infinite;
                }

                @keyframes bounce {
                    0%, 100% { transform: translateX(-50%) translateY(0); }
                    50% { transform: translateX(-50%) translateY(10px); }
                }

                .scroll-indicator svg {
                    width: 24px;
                    height: 24px;
                }

                /* Section Styles */
                .section {
                    padding: 80px 20px;
                    max-width: 1400px;
                    margin: 0 auto;
                }

                .section-header {
                    text-align: center;
                    margin-bottom: 60px;
                }

                .section-title {
                    font-family: 'Cinzel', serif;
                    font-size: 2.5rem;
                    font-weight: 700;
                    color: var(--text-light);
                    margin-bottom: 15px;
                    position: relative;
                }

                .section-title::after {
                    content: '';
                    display: block;
                    width: 80px;
                    height: 3px;
                    background: linear-gradient(90deg, transparent, var(--lorwyn-gold), transparent);
                    margin: 20px auto 0;
                }

                .section-subtitle {
                    font-size: 1.1rem;
                    color: var(--text-muted);
                    max-width: 700px;
                    margin: 0 auto;
                    line-height: 1.6;
                }

                /* About Section */
                .about-section {
                    background: linear-gradient(180deg, var(--shadowmoor-dark) 0%, var(--shadowmoor-blue) 50%, var(--shadowmoor-dark) 100%);
                }

                .about-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 40px;
                    margin-top: 40px;
                }

                .about-card {
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(201, 162, 39, 0.2);
                    border-radius: 16px;
                    padding: 40px;
                    text-align: center;
                    transition: all 0.3s ease;
                }

                .about-card:hover {
                    transform: translateY(-5px);
                    border-color: var(--lorwyn-gold);
                    box-shadow: 0 10px 40px rgba(201, 162, 39, 0.15);
                }

                .about-card-icon {
                    font-size: 3rem;
                    margin-bottom: 20px;
                }

                .about-card-title {
                    font-family: 'Cinzel', serif;
                    font-size: 1.3rem;
                    font-weight: 600;
                    color: var(--lorwyn-gold-light);
                    margin-bottom: 15px;
                }

                .about-card-text {
                    font-size: 1rem;
                    color: var(--text-muted);
                    line-height: 1.6;
                }

                /* Events Section */
                .events-section {
                    background:
                        linear-gradient(180deg,
                            rgba(13, 13, 26, 0.85) 0%,
                            rgba(42, 13, 62, 0.85) 50%,
                            rgba(13, 13, 26, 0.85) 100%),
                        url('https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/bnduaeuybryo34bghuerobhue.jpg');
                    background-size: cover;
                    background-position: center;
                    background-attachment: fixed;
                }

                .events-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 30px;
                }

                .event-card {
                    background: rgba(0, 0, 0, 0.4);
                    border: 1px solid rgba(201, 162, 39, 0.3);
                    border-radius: 16px;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }

                .event-card:hover {
                    transform: translateY(-5px);
                    border-color: var(--lorwyn-gold);
                    box-shadow: 0 15px 40px rgba(201, 162, 39, 0.2);
                }

                .event-card-header {
                    background: linear-gradient(135deg, var(--lorwyn-purple) 0%, var(--lorwyn-green) 100%);
                    padding: 12px;
                    text-align: center;
                }

                .event-card-header.ploiesti {
                    background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
                }

                .event-card-header.brasov {
                    background: linear-gradient(135deg, #1e88e5 0%, #0d47a1 100%);
                }

                .event-card-title {
                    font-family: 'Cinzel', serif;
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: var(--text-light);
                }

                .event-card-title-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .event-card-title-text {
                    font-family: 'Cinzel', serif;
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: var(--text-light);
                }

                .event-card-title-logo {
                    height: 40px;
                    width: auto;
                    object-fit: contain;
                    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));
                }

                .event-card-body {
                    padding: 25px;
                }

                .event-detail {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 15px;
                    color: var(--text-muted);
                }

                .event-detail:last-of-type {
                    margin-bottom: 0;
                }

                .event-detail-icon {
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--lorwyn-gold);
                }

                .event-detail-text {
                    font-size: 0.95rem;
                }

                .event-detail-text strong {
                    color: var(--text-light);
                }

                .event-location-logo {
                    height: 30px;
                    width: auto;
                    object-fit: contain;
                }

                .event-card-footer {
                    padding: 0 25px 25px;
                }

                .event-btn {
                    display: block;
                    width: 100%;
                    padding: 14px;
                    background: linear-gradient(135deg, var(--lorwyn-gold) 0%, var(--lorwyn-gold-light) 100%);
                    color: var(--shadowmoor-dark);
                    font-weight: 700;
                    text-align: center;
                    text-decoration: none;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    font-size: 0.9rem;
                }

                .event-btn:hover {
                    box-shadow: 0 5px 20px rgba(201, 162, 39, 0.5);
                }

                .event-btn.sold-out {
                    background: linear-gradient(135deg, #666 0%, #444 100%);
                    cursor: not-allowed;
                    opacity: 0.6;
                }

                .event-btn.sold-out:hover {
                    box-shadow: none;
                }

                .event-card.sold-out {
                    opacity: 0.7;
                }

                .event-card.sold-out .event-card-header {
                    background: linear-gradient(135deg, #555 0%, #333 100%);
                }

                .event-card.sold-out .event-card-header.ploiesti,
                .event-card.sold-out .event-card-header.brasov {
                    background: linear-gradient(135deg, #555 0%, #333 100%);
                }

                /* Products Section */
                .products-section {
                    background:
                        linear-gradient(180deg,
                            rgba(13, 13, 26, 0.85) 0%,
                            rgba(13, 13, 26, 0.85) 100%),
                        url('https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/bnduaeuybryo34bghuerobhue.jpg');
                    background-size: cover;
                    background-position: center;
                    background-attachment: fixed;
                }

                .products-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 30px;
                }

                .product-card {
                    background: rgba(255, 255, 255, 0.02);
                    border: 1px solid rgba(201, 162, 39, 0.15);
                    border-radius: 16px;
                    overflow: hidden;
                    transition: all 0.3s ease;
                    position: relative;
                }

                .product-card:hover {
                    transform: translateY(-8px);
                    border-color: var(--lorwyn-gold);
                    box-shadow: 0 20px 50px rgba(201, 162, 39, 0.2);
                }

                .product-badge {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: linear-gradient(135deg, var(--lorwyn-purple) 0%, var(--lorwyn-gold) 100%);
                    color: var(--text-light);
                    font-size: 0.7rem;
                    font-weight: 700;
                    padding: 6px 12px;
                    border-radius: 20px;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    z-index: 10;
                }

                .product-image-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 100%;
                    background: linear-gradient(135deg, rgba(74, 26, 107, 0.3) 0%, rgba(26, 74, 46, 0.3) 100%);
                    overflow: hidden;
                }

                .product-image {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 85%;
                    height: 85%;
                    object-fit: contain;
                    transition: transform 0.3s ease;
                }

                .product-card:hover .product-image {
                    transform: translate(-50%, -50%) scale(1.05);
                }

                .product-info {
                    padding: 25px;
                    text-align: center;
                }

                .product-name {
                    font-family: 'Cinzel', serif;
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: var(--text-light);
                    margin-bottom: 10px;
                }

                .product-price {
                    font-size: 1.4rem;
                    font-weight: 700;
                    color: var(--lorwyn-gold);
                    margin-bottom: 20px;
                }

                .product-price span {
                    font-size: 0.9rem;
                    color: var(--text-muted);
                    font-weight: 400;
                }

                .product-btn {
                    display: inline-block;
                    padding: 12px 30px;
                    background: transparent;
                    color: var(--lorwyn-gold);
                    border: 2px solid var(--lorwyn-gold);
                    border-radius: 8px;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    font-size: 0.85rem;
                    letter-spacing: 1px;
                }

                .product-btn:hover {
                    background: var(--lorwyn-gold);
                    color: var(--shadowmoor-dark);
                }

                .product-btn.sold-out {
                    background: transparent;
                    color: #666;
                    border-color: #666;
                    cursor: not-allowed;
                    opacity: 0.6;
                }

                .product-btn.sold-out:hover {
                    background: transparent;
                    color: #666;
                    transform: none;
                }

                .product-card.sold-out {
                    opacity: 0.7;
                }

                .product-card.sold-out .product-image {
                    filter: grayscale(0.5);
                }

                .sold-out-overlay {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(0, 0, 0, 0.8);
                    color: #ff4444;
                    padding: 10px 20px;
                    border-radius: 8px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    font-size: 1.1rem;
                    z-index: 10;
                    border: 2px solid #ff4444;
                }

                /* Info Section */
                .info-section {
                    background:
                        linear-gradient(180deg,
                            rgba(13, 13, 26, 0.85) 0%,
                            rgba(26, 32, 64, 0.85) 100%),
                        url('https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/bnduaeuybryo34bghuerobhue.jpg');
                    background-size: cover;
                    background-position: center;
                    background-attachment: fixed;
                }

                .info-content {
                    background: rgba(0, 0, 0, 0.3);
                    border: 1px solid rgba(201, 162, 39, 0.2);
                    border-radius: 20px;
                    padding: 50px;
                    text-align: center;
                }

                .info-title {
                    font-family: 'Cinzel', serif;
                    font-size: 1.8rem;
                    font-weight: 700;
                    color: var(--lorwyn-gold-light);
                    margin-bottom: 20px;
                }

                .info-text {
                    font-size: 1.1rem;
                    color: var(--text-muted);
                    line-height: 1.8;
                    max-width: 800px;
                    margin: 0 auto 30px;
                }

                .info-list {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    gap: 30px;
                    margin-top: 30px;
                    list-style: none;
                }

                .info-list li {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    color: var(--text-light);
                    font-size: 1rem;
                }

                .info-list li::before {
                    content: '✦';
                    color: var(--lorwyn-gold);
                }

                /* Footer CTA */
                .footer-cta {
                    background: linear-gradient(180deg, var(--shadowmoor-blue) 0%, var(--shadowmoor-dark) 100%);
                    padding: 80px 20px;
                    text-align: center;
                }

                .footer-cta-content {
                    max-width: 800px;
                    margin: 0 auto;
                }

                .footer-logo {
                    width: 200px;
                    margin: 0 auto 30px;
                    display: block;
                }

                .footer-text {
                    font-size: 1.1rem;
                    color: var(--text-muted);
                    margin-bottom: 30px;
                    line-height: 1.6;
                }

                .footer-links {
                    display: flex;
                    justify-content: center;
                    gap: 30px;
                    flex-wrap: wrap;
                }

                .footer-link {
                    color: var(--lorwyn-gold);
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.3s ease;
                }

                .footer-link:hover {
                    color: var(--lorwyn-gold-light);
                    text-decoration: underline;
                }

                .copyright {
                    margin-top: 50px;
                    padding-top: 30px;
                    border-top: 1px solid rgba(201, 162, 39, 0.2);
                    color: var(--text-muted);
                    font-size: 0.85rem;
                }

                /* Responsive */
                @media (max-width: 1024px) {
                    .section-title {
                        font-size: 2rem;
                    }

                    .hero-tagline {
                        font-size: 1.2rem;
                    }

                    .hero-logo {
                        max-width: 450px;
                    }
                }

                @media (max-width: 768px) {
                    .hero {
                        min-height: 90vh;
                        padding: 60px 20px;
                    }

                    .krit-badge {
                        display: none;
                    }

                    .hero-logo {
                        max-width: 320px;
                    }

                    .magic-logo {
                        max-width: 150px;
                    }

                    .hero-tagline {
                        font-size: 1rem;
                        letter-spacing: 2px;
                    }

                    .hero-subtitle {
                        font-size: 0.95rem;
                    }

                    .release-badge {
                        flex-direction: column;
                        padding: 12px 25px;
                    }

                    .release-badge-date {
                        font-size: 1.2rem;
                    }

                    .hero-buttons {
                        flex-direction: column;
                        width: 100%;
                        max-width: 300px;
                    }

                    .btn {
                        width: 100%;
                        padding: 14px 30px;
                    }

                    .section {
                        padding: 60px 20px;
                    }

                    .section-title {
                        font-size: 1.6rem;
                    }

                    .section-subtitle {
                        font-size: 1rem;
                    }

                    .about-grid {
                        gap: 20px;
                    }

                    .about-card {
                        padding: 30px;
                    }

                    .events-grid {
                        grid-template-columns: 1fr;
                    }

                    .products-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 15px;
                    }

                    .product-info {
                        padding: 15px;
                    }

                    .product-name {
                        font-size: 0.95rem;
                    }

                    .product-price {
                        font-size: 1.1rem;
                    }

                    .product-btn {
                        padding: 10px 20px;
                        font-size: 0.75rem;
                    }

                    .info-content {
                        padding: 30px 20px;
                    }

                    .info-title {
                        font-size: 1.4rem;
                    }

                    .info-text {
                        font-size: 1rem;
                    }

                    .info-list {
                        flex-direction: column;
                        align-items: center;
                        gap: 15px;
                    }

                    .scroll-indicator {
                        display: none;
                    }
                }

                @media (max-width: 480px) {
                    .hero-logo {
                        max-width: 260px;
                    }

                    .hero-tagline {
                        font-size: 0.85rem;
                    }

                    .products-grid {
                        grid-template-columns: 1fr;
                    }

                    .footer-links {
                        flex-direction: column;
                        gap: 15px;
                    }
                }
            `}</style>

            {/* JSON-LD Structured Data */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Event",
                        "name": "Magic: The Gathering Lorwyn Eclipsed Prerelease",
                        "description": "Participă la evenimentele Prerelease pentru Magic: The Gathering - Lorwyn Eclipsed. Evenimente disponibile în Ploiești și Brașov.",
                        "startDate": "2026-01-16T18:30:00+02:00",
                        "endDate": "2026-01-18T23:00:00+02:00",
                        "eventStatus": "https://schema.org/EventScheduled",
                        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                        "image": "https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/3H8hMTEhhnho_HeroHeader_1023x600.webp",
                        "location": [
                            {
                                "@type": "Place",
                                "name": "KRIT Ploiești",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "Strada Piața Victoriei, Nr. 4",
                                    "addressLocality": "Ploiești",
                                    "addressCountry": "RO"
                                }
                            },
                            {
                                "@type": "Place",
                                "name": "KRIT Brașov",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "Str. Lunga, Nr. 51",
                                    "addressLocality": "Brașov",
                                    "addressCountry": "RO"
                                }
                            }
                        ],
                        "organizer": {
                            "@type": "Organization",
                            "name": "KRIT - Board Games & Card Games",
                            "url": "https://krit.ro",
                            "logo": "https://content.krit.ro/public-assets/landing-assets/logo.png"
                        },
                        "offers": {
                            "@type": "AggregateOffer",
                            "lowPrice": "149.00",
                            "highPrice": "159.99",
                            "priceCurrency": "RON",
                            "availability": "https://schema.org/LimitedAvailability",
                            "url": "https://krit.ro/landing/mtg-lorwyn-eclipsed"
                        }
                    })
                }}
            />

            <div className="landing-container">
                {/* Hero Section */}
                <section className="hero">
                    <a href="https://krit.ro" className="krit-badge" target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://content.krit.ro/public-assets/landing-assets/logo.png"
                            alt="KRIT Logo"
                            className="krit-badge-logo"
                        />
                        <span className="krit-badge-text">Înapoi la site</span>
                    </a>
                    <div className="particles">
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                        <div className="particle"></div>
                    </div>
                    <div className="hero-content">
                        <img
                            src="https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/magic-logo.webp"
                            alt="Magic: The Gathering"
                            className="magic-logo"
                        />
                        <img
                            src="https://content.krit.ro/public-assets/landing-assets/lorwyn-eclipsed-prerelease/3H8hMTEhhnho_660x237.webp"
                            alt="Lorwyn Eclipsed Logo"
                            className="hero-logo"
                        />
                        <p className="hero-tagline">Return to the Land of Light and Shadow</p>
                        <p className="hero-subtitle">
                            Îndrăznește să pătrunzi în planul în continuă schimbare al lui Lorwyn și Shadowmoor
                            și descoperă-ți adevărata esență.
                        </p>

                        <div className="release-badge">
                            <span className="release-badge-label">Prerelease</span>
                            <span className="release-badge-date">16-18 Ianuarie 2026</span>
                        </div>

                        <div className="hero-buttons">
                            <a href="#events" className="btn btn-primary">Înscrie-te la Prerelease</a>
                            <a href="#products" className="btn btn-secondary">Vezi Produsele</a>
                        </div>
                    </div>

                    <div className="scroll-indicator">
                        <span>Descoperă mai mult</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </section>

                {/* Events Section */}
                <section className="events-section" id="events">
                    <div className="section">
                        <div className="section-header">
                            <h2 className="section-title">Evenimente Prerelease</h2>
                            <p className="section-subtitle">
                                Fii printre primii care deschid și joacă cu noile cărți Lorwyn Eclipsed!
                                Alege locația și data care ți se potrivește.
                            </p>
                        </div>

                        <div className="events-grid">
                            {events.map((event, index) => {
                                const locationClass = event.location.includes('Ploiești') ? 'ploiesti' : event.location.includes('Brașov') ? 'brasov' : '';
                                return (
                                    <div className={`event-card ${event.soldOut ? 'sold-out' : ''}`} key={index}>
                                        <div className={`event-card-header ${locationClass}`}>
                                            <div className="event-card-title-wrapper">
                                                <span className="event-card-title-text">{event.title.split(' ')[0]} {event.title.split(' ')[1]}</span>
                                                {event.locationLogo && (
                                                    <img
                                                        src={event.locationLogo}
                                                        alt={event.location}
                                                        className="event-card-title-logo"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="event-card-body">
                                            <div className="event-detail">
                                                <span className="event-detail-icon">📅</span>
                                                <span className="event-detail-text">{event.date}</span>
                                            </div>
                                            <div className="event-detail">
                                                <span className="event-detail-icon">🕐</span>
                                                <span className="event-detail-text">Ora {event.time}</span>
                                            </div>
                                            <div className="event-detail">
                                                <span className="event-detail-icon">📍</span>
                                                <span className="event-detail-text">{event.address}</span>
                                            </div>
                                            <div className="event-detail">
                                                <span className="event-detail-icon">💰</span>
                                                <span className="event-detail-text"><strong>{event.price}</strong></span>
                                            </div>
                                        </div>
                                        <div className="event-card-footer">
                                            {event.soldOut ? (
                                                <span className="event-btn sold-out">SOLD OUT</span>
                                            ) : (
                                                <a href={event.url} className="event-btn">Înscrie-te Acum</a>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>

                {/* Products Section */}
                <section className="products-section" id="products">
                    <div className="section">
                        <div className="section-header">
                            <h2 className="section-title">Descoperă Lorwyn Eclipsed</h2>
                            <p className="section-subtitle">
                                Precomandă produsele Lorwyn Eclipsed și fii pregătit pentru lansare!
                            </p>
                        </div>

                        <div className="products-grid">
                            {products.map((product, index) => (
                                <div className={`product-card ${product.soldOut ? 'sold-out' : ''}`} key={index}>
                                    {product.badge && (
                                        <span className="product-badge">{product.badge}</span>
                                    )}
                                    <div className="product-image-wrapper">
                                        {product.soldOut && (
                                            <div className="sold-out-overlay">SOLD OUT</div>
                                        )}
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="product-image"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="product-info">
                                        <h3 className="product-name">{product.name}</h3>
                                        <p className="product-price">
                                            {product.price} <span>LEI</span>
                                        </p>
                                        {product.soldOut ? (
                                            <span className="product-btn sold-out">Indisponibil</span>
                                        ) : (
                                            <a href={product.url} className="product-btn">Precomandă</a>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <a href="https://krit.ro/cautare/lorwyn%2Beclipsed" className="btn btn-secondary">
                                Vezi Toate Produsele
                            </a>
                        </div>
                    </div>
                </section>

                {/* Info Section */}
                <section className="info-section">
                    <div className="section">
                        <div className="info-content">
                            <h2 className="info-title">Ce Primești la Prerelease?</h2>
                            <p className="info-text">
                                Prerelease-ul este primul eveniment oficial în care jucătorii pot deschide
                                și utiliza noile cărți Lorwyn Eclipsed într-un mediu casual și prietenos.
                                Fiecare participant își construiește un pachet de 40 de cărți din pachetele
                                primite și îl testează împotriva altor jucători!
                            </p>

                            <ul className="info-list">
                                <li>1x Prerelease Pack Lorwyn: Eclipsed</li>
                                <li>Format: Sealed Deck (40 cărți)</li>
                                <li>3-4 Runde Swiss</li>
                                <li>Premii: 1 Play Booster / Victorie</li>
                                <li>Meciuri Best-of-3</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Footer CTA */}
                <p className="px-5 py-6 text-center text-xs text-slate-400">Magic: The Gathering și Lorwyn Eclipsed sunt mărci înregistrate ale Wizards of the Coast LLC.</p>
            </div>
        </>
    );
};

export default LorwynEclipsedLanding;
